import api from "@/api/api";
import { dictionary } from "@/shared/services/dictionary";
import { isNull } from "@/shared/utils/utils";
import moment from "moment";
import {
  Field,
  Icon,
  CellGroup,
  DatetimePicker,
  Dialog,
  Popup,
  Form,
  Uploader,
  Button,
  DropdownMenu,
  DropdownItem,
  Area,
} from "vant";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    [Field.name]: Field,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Form.name]: Form,
    [Uploader.name]: Uploader,
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Area.name]: Area,
  },
})
export default class EducateResumeEdit extends Vue {
  // 正在提交
  submitting = false;
  openId = "";
  isPool: any = 0; // 人才库进入（1）或招聘进入（0）
  resumeInfo: any = {}; // 简历信息
  itemInfo: any = {};
  resumeId: any = "";
  id: any = "";

  isUnifiedRecruitOptions: any[] = [
    { text: "是", value: "true" },
    { text: "否", value: "false" },
  ];
  // 熟练程度选项
  knowLevelList: any[] = [];
  // 日期弹窗的值
  dateValues: any = {};
  // 日期弹窗的状态
  dateShowState: any = {};
  // 地址弹窗的状态
  areaShowState: any = {};
  // 地址控件的值
  areaValues: any = {};

  areaList: any = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    province_list: {},
    // eslint-disable-next-line @typescript-eslint/camelcase
    city_list: {},
  };

  areaLists: any = {
    // eslint-disable-next-line @typescript-eslint/camelcase
    province_list: {},
    // eslint-disable-next-line @typescript-eslint/camelcase
    city_list: {},
    // eslint-disable-next-line @typescript-eslint/camelcase
    county_list: {},
  };

  ErrorMsg = "";
  phoneNumberName = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
  nameMsg = "";
  memberRelationMsg = "";
  created() {
    this.isPool = sessionStorage.getItem("isPool");
    const wechatUser = JSON.parse(sessionStorage.getItem("wechatUser") || "{}");
    this.openId = wechatUser.openid;
    console.log(this.openId);
    this.resumeId = this.$route.query.resumeId || "";
    this.id = this.$route.query.id || "";
    this.initDictionary();
    this.initAreaOption();
  }

  mounted() {
    if (this.resumeId) {
      this.initResumeInfo();
    }
  }

  // 初始化简历
  initResumeInfo() {
    const resumeApi =
      this.isPool === "1" ? api.getTalentPoolResume : api.getRecruitResume;
    resumeApi({ openId: this.openId, id: this.resumeId }).then((res: any) => {
      this.resumeInfo = res.resumeInfo;
      if (this.id) {
        this.getEditData();
        this.initResumeArea();
      }
      this.initTimeValues();
    });
  }

  // 地址控件点击
  onAreaFieldClick(field: string) {
    this.areaShowState[field] = true;
    this.areaShowState = Object.assign({}, this.areaShowState);
    console.log(this.areaShowState);
  }

  // 初始化地址选项
  initAreaOption() {
    api.getProvinceAndCity().then((res: any) => {
      const areas: any[] = res.allDistricts || [];
      areas.forEach((area: any) => {
        if (area.levelNo === 1) {
          this.areaList.province_list[area.code] = area.name;
          this.areaLists.province_list[area.code] = area.name;
        }
        if (area.levelNo === 2) {
          this.areaList.city_list[area.code] = area.name;
          this.areaLists.city_list[area.code] = area.name;
        }
        if (area.levelNo === 3) {
          this.areaLists.county_list[area.code] = area.name;
        }
      });
      if (this.resumeInfo.id) {
        this.initResumeArea();
      }
    });
  }

  // 地址控件确认
  onAreaConfirm(event: any, field: string) {
    console.log(event);
    this.areaValues[field] = event[0].name + "/" + event[1].name + "/" + event[2].name;
    if (field === "addressCounty") {
      this.itemInfo["addressCountyCode"] = event[2].code;
      this.itemInfo["addressCityCode"] = event[1].code;
      this.itemInfo["addressProCode"] = event[0].code;
    }
    this.onAreaCancle(field);
  }

  // 验证手机号格式
  phoneNumberChange() {
    if (
      this.itemInfo.phoneNumber &&
      !this.phoneNumberName.test(this.itemInfo.phoneNumber)
    ) {
      this.ErrorMsg = "请输入正确格式手机号";
    } else {
      this.ErrorMsg = "";
    }
  }

  nameChange() {
    if (!this.itemInfo.memberName) {
      this.nameMsg = "姓名为必填项";
    } else {
      this.nameMsg = "";
    }
  }

  memberRelationChange() {
    if (!this.itemInfo.memberRelation) {
      this.memberRelationMsg = "与本人关系为必填项";
    } else {
      this.memberRelationMsg = "";
    }
  }

  // 初始化简历的地址控件值
  initResumeArea() {
    if (this.itemInfo["addressCountyCode"]) {
      const countryCode = this.itemInfo["addressCountyCode"];
      const cityCode = this.getCityCodeByCityCode(countryCode);
      const proCode = this.getProCodeByCityCode(countryCode);
      this.areaValues["addressCounty"] =
        this.areaLists.province_list[proCode] +
        "/" +
        this.areaLists.city_list[cityCode] +
        "/" +
        this.areaLists.county_list[countryCode];
    }
    this.areaValues = Object.assign({}, this.areaValues);
  }

  /**
   * 根据区县的 Code 获取对应省份的 Code
   */
  getProCodeByCityCode(countryCode: string): string {
    if (!countryCode) {
      return "";
    }
    const proCode = countryCode.substr(0, 2) + "0000";
    return proCode;
  }
  /**
   * 根据区县的 Code 获取对应城市的 Code
   */
  getCityCodeByCityCode(countryCode: string): string {
    if (!countryCode) {
      return "";
    }
    const cityCode = countryCode.substr(0, 4) + "00";
    return cityCode;
  }

  // 地址控件取消
  onAreaCancle(field: any) {
    this.areaShowState[field] = false;
    this.areaShowState = Object.assign({}, this.areaShowState);
  }

  getEditData() {
    const item = this.resumeInfo["members"].find((item: any) => {
      return item.id === this.id;
    });
    if (item) {
      this.itemInfo = item;
    }
  }

  // 初始化时间控件值
  initTimeValues() {
    if (this.itemInfo.birthdayDate) {
      this.itemInfo.birthdayDate = moment(this.itemInfo.birthdayDate).format(
        "YYYY-MM-DD"
      );
    }
  }

  // 初始化字典值
  initDictionary() {
    // 熟练程度选项
    api.getDictionaries([dictionary.knowLevel]).then((res: any) => {
      const datas: any[] = res.data || [];
      this.knowLevelList = datas.map((d) => {
        return {
          text: d.name,
          value: d.name,
        };
      });
    });
  }

  // 日期输入框点击
  timeControlOnClicked(field: string) {
    let date = this.resumeInfo[field];
    if (isNull(date)) {
      date = new Date();
    }
    this.dateValues[field] = new Date(date);
    this.dateShowState[field] = true;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击取消
  timePopupOnCancel(field: string) {
    this.dateShowState[field] = false;
    this.dateShowState = Object.assign({}, this.dateShowState);
  }

  // 日期框点击确认
  timePopupOnConfirm(val: any, field: string) {
    this.itemInfo[field] = moment(val).format("YYYY-MM-DD");
    this.timePopupOnCancel(field);
  }

  validat(): boolean {
    const validator: any = {
      memberRelation: {
        name: "与本人关系",
      },
      memberName: {
        name: "姓名",
      },
      phoneNumber: {
        name: "联系方式",
      },
    };
    const keys = Object.keys(validator);
    for (const key of keys) {
      const value = this.itemInfo[key];
      if (isNull(value)) {
        Dialog({ message: validator[key].name + "为必填项" });
        return false;
      }
    }
    return true;
  }

  // 提交
  submit() {
    if (this.submitting) {
      return;
    }
    this.submitting = true;
    if (!this.validat()) {
      return;
    }
    if (!this.id) {
      if (!this.resumeInfo["members"]) {
        this.resumeInfo["members"] = [];
      }
      this.resumeInfo["members"].push(this.itemInfo);
    }
    this.editResumeInfo();
  }

  editResumeInfo() {
    const isPool = sessionStorage.getItem("isPool");
    const editResumeApi =
      isPool === "1" ? api.editTalentPoolResume : api.editRecruitResume;

    const entity = {
      openId: this.openId,
      resumeInfo: this.resumeInfo,
    };
    editResumeApi(entity).then((res) => {
      this.$router.push(`/resume-detail?resumeId=${this.resumeId}`);
    }).finally(() => { 
      this.submitting = false;
    });
  }
}
